import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { UpdateAgentFirmUserProps } from './types';

type UpdateAgentFirmUserParams = {
  agentFirmId: string;
  userId: string;
  data: UpdateAgentFirmUserProps;
};

export async function updateAgentFirmUser({
  agentFirmId,
  userId,
  data,
}: UpdateAgentFirmUserParams) {
  const response = await fetcher(
    `${API_BASE_PATH}/${agentFirmId}/users/${userId}`,
    {
      method: 'POST',
      body: data,
    }
  );

  if (!response.ok) {
    const responseData = await response.json();
    return {
      success: false,
      error: responseData?.message || 'Failed to update agent firm user',
      statusCode: response.status,
    };
  }

  return {
    success: true,
  };
}
